import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { useSelector } from 'react-redux'
import { useTranslation } from '../../../services/static-text/hooks'
import { TARGET_BLANK } from '../../Link/constants'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import Link from '../../Link/index'
import { getHelpCenterUrl } from '../../../services/url/index'
import ErrorMessage from '../../ErrorMessage/index'
import { GIFT_PAYMENT_PAGE_STATIC_KEY as staticTextStoreKey } from './gift-payment-page-static-key'

const ErrorsPropTypes = {
  errorKey: PropTypes.string,
}

/**
 * @type {React.FC<PropTypes.InferProps<ErrorsPropTypes>>}
 * @returns {React.ReactElement}
 * */
export const Errors = ({ errorKey }) => {
  const translateByKey = useTranslation(staticTextStoreKey)
  const language = useSelector(selectPrimaryLanguage)
  if (isNil(errorKey)) {
    return null
  }

  const orderErrorMessages = [translateByKey(errorKey)]

  return (
    <>
      <ErrorMessage errorMessages={orderErrorMessages} />
      <Link
        key={getHelpCenterUrl(language)}
        id={getHelpCenterUrl(language)}
        to={getHelpCenterUrl(language)}
        directLink
        target={TARGET_BLANK}
      >
        {translateByKey('customerSupport')}
      </Link>
    </>
  )
}

Errors.propTypes = ErrorsPropTypes

export default Errors
